module.exports = __webpack_public_path__ + "28e7eb413b95267947ded94fe044fb9a.svg";